import { UIMenuItem, UITab } from '@constants';
import { useCheckScreenWithCallback } from '@hooks';
import React, { memo, useCallback, useState } from 'react';
import trans from 'translation';
import { KBreadcrumbs, KContainer, KGrid, KTab } from 'uikit';

import Email from './Email';
import Invoice from './Invoice';
import Notification from './Notification';
import OneStop from './OneStop';
import OneStopComtrac from './OneStopComtrac';

const ApiIntegration = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const cb = useCallback(() => {
    let _tabs = [
      {
        code: UITab.ApiIntegrationCommon,
        label: trans('common')
      },
      {
        code: UITab.ApiIntegrationOneStop,
        label: trans('one_stop')
      }
    ];

    return _tabs;
  }, []);

  const tabs = useCheckScreenWithCallback(cb, UIMenuItem.ApiIntegration);

  return (
    <>
      <KBreadcrumbs
        hasBackIcon={false}
        breadcrumbs={[
          trans('routes.system_setting'),
          trans('routes.api_integration')
        ]}
      />

      <KContainer.View padding="0.75rem">
        <KTab.White tabIndex={tabIndex} onChangeTab={setTabIndex} tabs={tabs} />

        <KTab.Panel
          value={tabIndex}
          index={tabs.findIndex(i => i.code === UITab.ApiIntegrationCommon)}
        >
          <KGrid.Container style={{ marginTop: 0 }}>
            <KGrid.Item xs={12} sm={12} md={6}>
              <Invoice />
            </KGrid.Item>

            <KGrid.Item xs={12} sm={12} md={6}>
              <Email />
            </KGrid.Item>

            <KGrid.Item xs={12} sm={12} md={6}>
              <Notification />
            </KGrid.Item>
          </KGrid.Container>
        </KTab.Panel>

        <KTab.Panel
          value={tabIndex}
          index={tabs.findIndex(i => i.code === UITab.ApiIntegrationOneStop)}
        >
          <KGrid.Container style={{ marginTop: 0 }}>
            <KGrid.Item xs={12} sm={12} md={6}>
              <OneStop />
            </KGrid.Item>

            <KGrid.Item xs={12} sm={12} md={6}>
              <OneStopComtrac hasHeight />
            </KGrid.Item>
          </KGrid.Container>
        </KTab.Panel>
      </KContainer.View>
    </>
  );
};

export default memo(ApiIntegration);
